export default __webpack_public_path__ + "static/media/disaster1.4cedb402.png";